import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 180px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Skeleton, styled } from "@mui/material";
export const CategoryListPageSkeletonItem = ()=>{
    return /*#__PURE__*/ _jsxs(SkeletonItemContainer, {
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                height: 224,
                width: "100%"
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                height: 26,
                width: 137,
                sx: {
                    marginTop: "8px"
                }
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                height: 48,
                width: "100%",
                sx: {
                    marginTop: "8px"
                }
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                height: 20,
                width: 64,
                sx: {
                    marginTop: "4px"
                }
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                height: 26,
                width: 144,
                sx: {
                    marginTop: "16px"
                }
            })
        ]
    });
};
// LNB 영역 스켈레톤
export const CategoryLNBSkeleton = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                height: 24,
                width: 120,
                sx: {
                    marginBottom: "16px"
                }
            }),
            Array.from({
                length: 8
            }).map((_, idx)=>/*#__PURE__*/ _jsx(Skeleton, {
                    variant: "rectangular",
                    height: 20,
                    width: Math.random() * 60 + 80,
                    sx: {
                        marginBottom: "12px",
                        marginLeft: idx > 0 ? "".concat(Math.min(idx * 8, 24), "px") : "0px"
                    }
                }, idx))
        ]
    });
};
// 브레드크럼 영역 스켈레톤
export const BreadcrumbSkeleton = ()=>{
    return /*#__PURE__*/ _jsx(Skeleton, {
        variant: "rectangular",
        width: "100%",
        height: 133,
        sx: {
            marginTop: "16px"
        }
    });
};
// 헤더 영역 스켈레톤
export const HeaderSkeleton = ()=>{
    return /*#__PURE__*/ _jsx(Skeleton, {
        variant: "rectangular",
        height: 24,
        width: 200,
        sx: {
            marginTop: "16px"
        }
    });
};
export const SkeletonItemContainer = styled("div")(_templateObject());
